/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './card-section-carousel.scss';
import C4DContentSection from '../content-section/content-section';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * The Card Section Carousel pattern
 *
 * @element c4d-card-section-carousel
 */
@customElement(`${c4dPrefix}-card-section-carousel`)
class C4DCardSectionCarousel extends C4DContentSection {
  static get stableSelector() {
    return `${c4dPrefix}--card-section-carousel`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The card-section-carousel component has been deprecated in favor of the content-section/block component combined with carousel. ' +
    'See content-section/block and carousel documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DCardSectionCarousel;
